import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F8FAFC] px-4 text-center">
      <p className="text-8xl font-bold text-[#E2E8F0]">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-[#0F172A]">Page not found</h1>
      <p className="mt-2 text-sm text-[#64748B]">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <button
        type="button"
        onClick={() => navigate('/')}
        className="btn-secondary mt-8"
      >
        Go home
      </button>
    </div>
  );
}
